module.exports = __webpack_public_path__ + "static/media/grey4gold.96ca4873.png";